import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6bf75028"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bf75028')) {
      api.createRecord('6bf75028', component.options)
    } else {
      api.reload('6bf75028', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6bf75028", function () {
      api.rerender('6bf75028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AuthCode/index.vue"
export default component.exports